import { UIAnalyticsEvent, type UIAnalyticsEventProps } from '@atlaskit/analytics-next';

export const createTestEvent = (
	payload: UIAnalyticsEventProps = {
		payload: { action: 'thisIsADumyAction', actionSubject: 'thisIsADumyActionSubject' },
	},
) => new UIAnalyticsEvent(payload);
